module.exports = __webpack_public_path__ + "static/media/spiring.5a649ff9.svg";